import { Paperclip } from "lucide-react";

type Props = {
  count: number;
  /**
   * Sit in the flow instead of pinning to the corner.
   *
   * The worker calendar's blocks are only as tall as the job is long, so their rows are counted out
   * exactly — a badge floating in the corner would land on top of the time. There it rides at the end
   * of a row it shares.
   */
  inline?: boolean;
};

export const AttachmentBadge = ({ count, inline = false }: Props) => {
  if (count <= 0) return null;

  return (
    <span
      className={`${
        inline ? "" : "absolute top-0.5 right-0.5 z-10 pointer-events-none "
      }inline-flex items-center gap-0.5 h-4 min-w-4 px-1 rounded-full bg-black/25 text-white text-[9px] font-bold leading-none`}
    >
      <Paperclip className="w-3 h-3" strokeWidth={2.75} />
      <span>{count}</span>
    </span>
  );
};
